import React from "react";
import PropTypes from "prop-types";

import "./Button.scss";

const Button = (props) => {
  const { text, type, className, ...restProps } = props;
  const buttonClass =
    type === "next"
      ? `${className} next-button`
      : `${className} button-container`;

  return (
    <button className={buttonClass} {...restProps} type={type}>
      {text}
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
};

export default Button;
